<aside class="main-sidebar app-sidebar">
    <a href="./" class="brand-link">
        <img src="assets/images/logo.png" alt="7thaven Logo" class="brand-image">
        <span class="brand-text">7thaven</span>
        <i class="fas fa-chevron-left brand-collapse"></i>
    </a>

    <div class="sidebar">
        <nav class="mt-2">
            <ul class="nav nav-pills nav-sidebar flex-column" role="menu">
                <li class="nav-item" *ngFor="let item of navItems" [hidden]="!canRead(item.page)">
                    <a [routerLink]="item.route" [class]="isActive(item) ? 'nav-link active' : 'nav-link'">
                        <i [class]="item.icon + ' nav-icon'"></i>
                        <p>{{ item.label }}</p>
                    </a>
                </li>
            </ul>
        </nav>
    </div>

    <div class="app-sidebar-footer">
        <div class="sidebar-user">
            <img src="https://ui-avatars.com/api/?name={{userName()}}&background=073331&color=fff" alt="{{userName()}}">
            <div>
                <strong>{{userName()}}</strong>
                <small>{{userData?.rights?.adminType || 'Administrator'}}</small>
            </div>
            <a [routerLink]="['/logout']" title="Sign out"><i class="fas fa-sign-out-alt"></i></a>
        </div>
    </div>
</aside>
